/**
 * Check if the current object is not a empty object without any properties
 * @param {object} obj
 * @returns boolean
 */
function isEmptyObject(obj) {
  return (
    obj === null ||
    obj === undefined ||
    (typeof obj === 'object' && !Object.keys(obj).length)
  );
}

export default isEmptyObject;
